// Mirrors the backend get_context_url routing: articles -> /page, Computer
// threads -> /computer/tasks, everything else -> /search. GraphQL supplies the
// first entry UUID directly, so preserve the canonical UUID permalink instead
// of reconstructing the retired title slug on the client.
export function recentThreadLink({ entryUuid, mode, variant, }) {
    if (variant === 'ARTICLE') {
        return `/page/${entryUuid}`;
    }
    if (mode === 'COMPUTER') {
        return `/computer/tasks/${entryUuid}`;
    }
    return `/search/${entryUuid}`;
}
//# sourceMappingURL=recentThreadLink.js.map